<template>
  <div class="reset_password">
    <div class="reset_password-content">
      <div class="title">система контроля <br/> за ходом подготовки <br/> чемпионатов</div>
      <div class="reset_password-form" v-if="is2ndStep">
        <div class="form-title">Восстановление пароля</div>
        <div class="form-subtitle">Введите новый пароль</div>
        <div class="form-fields">
          <div class="form-error" v-if="errorMessage">{{errorMessage}}</div>
          <input type="password" class="form-field" placeholder="Введите пароль"
            v-model="password" @keydown.enter="submit2ndStep">
          <input type="password" class="form-field" placeholder="Повторите пароль"
            v-model="password_confirm" @keydown.enter="submit2ndStep">
        </div>
        <div class="form-actions">
          <button class="ccs-button" @click="submit2ndStep">Изменить пароль</button>
        </div>
      </div>
      <div class="reset_password-form" v-else>
        <div class="form-title">Восстановление пароля</div>
        <div class="form-subtitle">Введите Ваш email для того чтобы начать <br/>
        восстановление пароля</div>
        <div class="form-fields">
          <div class="form-error" v-if="errorMessage">{{errorMessage}}</div>
          <input type="text" class="form-field" placeholder="Ваш email"
            v-model="email" @keydown.enter="submit1stStep">
        </div>
        <div class="form-actions">
          <button class="ccs-button" @click="submit1stStep">Продолжить</button>
        </div>
      </div>
    </div>
    <img src="@/assets/images/branding.svg" alt="" class="reset_password-branding">
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'ResetPassword',
  data () {
    return {
      errorMessage: '',
      email: '',
      password: '',
      password_confirm: '',
    };
  },
  computed: {
    ...mapState('misc', ['siteSettings']),
    ...mapState('session', [
      'accessToken',
      'expiryTokenDate'
    ]),
    ...mapGetters('session', [
      'isAuthenticated'
    ]),
    is2ndStep() {
      return !!this.$route.params.token;
    }
  },
  methods: {
    ...mapActions('session', [
      'setToken',
      'logout',
      'setExpiryTokenDate'
    ]),
    submit1stStep() {
      axios({
        baseURL: process.env.VUE_APP_API_ENDPOINT,
        url: '/v1/reset_password',
        method: 'POST',
        data: {
          'email': this.email,
        }
      })
      .then(response => response.data)
      .then(({ error, message }) => {
        if (error) {
          this.handleServerError(error);
        }
        this.$toasted.success(message);
      })
      .catch((resp) => {
        const error = resp && resp.data && resp.data.error;
        if (error) {
          this.handleServerError(error);
        }
      });
    },
    isPasswordValid() {
      if (this.password !== this.password_confirm) {
        this.$toasted.error('Пароли не совпадают');
        return false;
      }
      if (this.password.length < 8) {
        this.$toasted.error('Мнимальная длина пароля - 8 символов');
        return false;
      }
      return true;
    },
    submit2ndStep() {
      if (this.isPasswordValid()) {
        this.submit2ndStepRequest();
      }
    },
    submit2ndStepRequest() {
      axios({
        baseURL: process.env.VUE_APP_API_ENDPOINT,
        url: `/v1/reset_password/${this.$route.params.token}`,
        method: 'POST',
        data: {
          'password': this.password,
        }
      })
      .then(response => response.data)
      .then(({ error, message }) => {
        if (error) {
          this.handleServerError(error);
        }
        this.$toasted.success(message);
        this.$router.push({ name: 'auth' });
      })
      .catch((resp) => {
        const error = resp && resp.data && resp.data.error;
        if (error) {
          this.handleServerError(error);
        }
      });
    },
    handleServerError(err) {
      this.errorMessage = err.message;
    },
  },
  mounted () {
    if (this.isAuthenticated) {
      this.$router.push({name: `dashboard_${this.siteSettings.defaultDashboardView}`});
    }
  }
};
</script>

<style lang="scss" scoped>
.reset_password {
  min-height: 100%;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background: $surfaceDarker;

  &-content {
    padding: 118px 0 0 132px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  &-branding {
    margin: auto 95px 95px 0;
    align-self: flex-end;
  }

  .title {
    color: #fff;
    font-size: 40px;
    font-weight: bold;
    line-height: 50px;
    text-transform: uppercase;
  }

  &-form {
    margin-top: 70px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    .form {

      &-title {
        color: #fff;
        font-weight: bold;
        font-size: 20px;
        line-height: 150%;
      }

      &-subtitle {
        margin-top: 20px;
        color: $primaryLighter;
        font-size: 14px;
        line-height: 150%;
      }

      &-error {
        margin-top: 20px;
        width: 100%;
        color: $secondaryLight
      }

      &-fields {
        margin-top: 5px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
      }

      &-field {
        padding: 5px 15px;
        margin-top: 20px;
        margin-right: 16px;
        height: 30px;
        width: 220px;
        border-radius: 5px;
        font-size: 14px;
        background: #fff;
      }

      &-actions {
        margin-top: 20px;
      }

    }

  }

}
</style>
